// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RmWx","colMin":"styles_colMin__154io"};